export const getNativeConfig = () => {
  return {
    native: {
      allowNavigation: ['*.sdui.dev', '*.sdux.de', 'sdui.app', 'iam.sdui-group.app'],
      appName: 'Sdui',
      packageName: 'com.sdui.sdui',
      defaultUrl: 'https://sdui.app',
      android: {
        flavor: 'sdui'
      },
      ios: {
        Scheme: 'Sdui'
      }
    }
  }
}
